"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Semester = exports.NewCourseData = exports.Course = exports.CourseData = void 0;
var http_client_1 = require("./http_client");
var user_1 = require("./user");
var utils_1 = require("./utils");
var CourseData = /** @class */ (function () {
    function CourseData(_a) {
        var pk = _a.pk, name = _a.name, semester = _a.semester, year = _a.year, subtitle = _a.subtitle, num_late_days = _a.num_late_days, allowed_guest_domain = _a.allowed_guest_domain, last_modified = _a.last_modified;
        this.pk = pk;
        this.name = name;
        this.semester = semester;
        this.year = year;
        this.subtitle = subtitle;
        this.num_late_days = num_late_days;
        this.allowed_guest_domain = allowed_guest_domain;
        this.last_modified = last_modified;
    }
    return CourseData;
}());
exports.CourseData = CourseData;
var Course = /** @class */ (function (_super) {
    __extends(Course, _super);
    function Course() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Course.subscribe = function (observer) {
        Course._subscribers.add(observer);
    };
    Course.unsubscribe = function (observer) {
        Course._subscribers.delete(observer);
    };
    Course.notify_course_created = function (course) {
        var e_1, _a;
        try {
            for (var _b = __values(Course._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_course_created(course);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    Course.notify_course_changed = function (course) {
        var e_2, _a;
        try {
            for (var _b = __values(Course._subscribers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subscriber = _c.value;
                subscriber.update_course_changed(course);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    Course.create = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var response, course;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/courses/", data)];
                    case 1:
                        response = _a.sent();
                        course = new Course(response.data);
                        Course.notify_course_created(course);
                        return [2 /*return*/, course];
                }
            });
        });
    };
    Course.get_all = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/courses/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (course_data) { return new Course(course_data); })];
                }
            });
        });
    };
    Course.get_courses_for_user = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, admin_courses, staff_courses, student_courses, handgrader_courses;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            user.courses_is_admin_for(),
                            user.courses_is_staff_for(),
                            user.courses_is_student_in(),
                            user.courses_is_handgrader_for()
                        ])];
                    case 1:
                        _a = __read.apply(void 0, [_b.sent(), 4]), admin_courses = _a[0], staff_courses = _a[1], student_courses = _a[2], handgrader_courses = _a[3];
                        return [2 /*return*/, {
                                courses_is_admin_for: admin_courses,
                                courses_is_staff_for: staff_courses,
                                courses_is_student_in: student_courses,
                                courses_is_handgrader_for: handgrader_courses,
                            }];
                }
            });
        });
    };
    Course.get_by_pk = function (pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/courses/" + pk + "/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new Course(response.data)];
                }
            });
        });
    };
    Course.get_by_fields = function (name, semester, year) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/course/" + name + "/" + semester + "/" + year + "/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new Course(response.data)];
                }
            });
        });
    };
    Course.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().patch("/courses/" + this.pk + "/", utils_1.filter_keys(this, Course.EDITABLE_FIELDS))];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, response.data);
                        Course.notify_course_changed(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    Course.prototype.delete = function () {
        return http_client_1.HttpClient.get_instance().delete("/courses/" + this.pk + "/");
    };
    Course.prototype.copy = function (new_name, new_semester, new_year) {
        return __awaiter(this, void 0, void 0, function () {
            var response, course;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/courses/" + this.pk + "/copy/", {
                            new_name: new_name,
                            new_semester: new_semester,
                            new_year: new_year
                        })];
                    case 1:
                        response = _a.sent();
                        course = new Course(response.data);
                        Course.notify_course_created(course);
                        return [2 /*return*/, course];
                }
            });
        });
    };
    Course.prototype.refresh = function () {
        return __awaiter(this, void 0, void 0, function () {
            var last_modified, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        last_modified = this.last_modified;
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/courses/" + this.pk + "/")];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, response.data);
                        if (last_modified !== this.last_modified) {
                            Course.notify_course_changed(this);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Course.prototype.get_admins = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/courses/" + this.pk + "/admins/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (user_data) { return new user_1.User(user_data); })];
                }
            });
        });
    };
    Course.prototype.add_admins = function (usernames) {
        return http_client_1.HttpClient.get_instance().post("/courses/" + this.pk + "/admins/", { 'new_admins': usernames });
    };
    Course.prototype.remove_admins = function (users) {
        return http_client_1.HttpClient.get_instance().patch("/courses/" + this.pk + "/admins/", { 'remove_admins': users });
    };
    Course.prototype.get_staff = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/courses/" + this.pk + "/staff/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (user_data) { return new user_1.User(user_data); })];
                }
            });
        });
    };
    Course.prototype.add_staff = function (usernames) {
        return http_client_1.HttpClient.get_instance().post("/courses/" + this.pk + "/staff/", { 'new_staff': usernames });
    };
    Course.prototype.remove_staff = function (users) {
        return http_client_1.HttpClient.get_instance().patch("/courses/" + this.pk + "/staff/", { 'remove_staff': users });
    };
    Course.prototype.get_students = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/courses/" + this.pk + "/students/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (user_data) { return new user_1.User(user_data); })];
                }
            });
        });
    };
    Course.prototype.add_students = function (usernames) {
        return http_client_1.HttpClient.get_instance().post("/courses/" + this.pk + "/students/", { 'new_students': usernames });
    };
    Course.prototype.remove_students = function (users) {
        return http_client_1.HttpClient.get_instance().patch("/courses/" + this.pk + "/students/", { 'remove_students': users });
    };
    Course.prototype.set_students = function (usernames) {
        return http_client_1.HttpClient.get_instance().put("/courses/" + this.pk + "/students/", { 'new_students': usernames });
    };
    Course.prototype.get_handgraders = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/courses/" + this.pk + "/handgraders/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (user_data) { return new user_1.User(user_data); })];
                }
            });
        });
    };
    Course.prototype.add_handgraders = function (usernames) {
        return http_client_1.HttpClient.get_instance().post("/courses/" + this.pk + "/handgraders/", { 'new_handgraders': usernames });
    };
    Course.prototype.remove_handgraders = function (users) {
        return http_client_1.HttpClient.get_instance().patch("/courses/" + this.pk + "/handgraders/", { 'remove_handgraders': users });
    };
    Course._subscribers = new Set();
    Course.EDITABLE_FIELDS = [
        'name',
        'semester',
        'year',
        'subtitle',
        'num_late_days',
        'allowed_guest_domain'
    ];
    return Course;
}(CourseData));
exports.Course = Course;
var NewCourseData = /** @class */ (function () {
    function NewCourseData(_a) {
        var name = _a.name, semester = _a.semester, year = _a.year, subtitle = _a.subtitle, num_late_days = _a.num_late_days;
        this.name = name;
        this.semester = semester;
        this.year = year;
        this.subtitle = subtitle;
        this.num_late_days = num_late_days;
    }
    return NewCourseData;
}());
exports.NewCourseData = NewCourseData;
var Semester;
(function (Semester) {
    Semester["fall"] = "Fall";
    Semester["winter"] = "Winter";
    Semester["spring"] = "Spring";
    Semester["summer"] = "Summer";
})(Semester = exports.Semester || (exports.Semester = {}));
//# sourceMappingURL=course.js.map